import { Component } from '@theme/component';

/**
 * @typedef {{ input: HTMLInputElement }} QuantitySelectorRefs
 */

/**
 * A number input with − / + controls (snippets/quantity.liquid). The buttons step the value
 * between the input's `min` (default 0) and `max`, then fire a bubbling `change` event on the
 * input, so the cart drawer or cart page can listen with `on:change` on an ancestor.
 *
 * @extends {Component<QuantitySelectorRefs>}
 */
class QuantitySelector extends Component {
  requiredRefs = ['input'];

  /** @param {Event} event */
  decrease(event) {
    event.preventDefault();
    this.#step(-1);
  }

  /** @param {Event} event */
  increase(event) {
    event.preventDefault();
    this.#step(1);
  }

  /** @param {number} delta */
  #step(delta) {
    const { input } = this.refs;
    const current = parseInt(input.value, 10) || 0;
    const min = parseInt(input.min, 10) || 0;
    const max = input.max === '' ? 9999 : parseInt(input.max, 10);
    const next = Math.min(Math.max(current + delta, min), Number.isNaN(max) ? 9999 : max);
    if (next === current) return;
    input.value = String(next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

if (!customElements.get('quantity-selector')) {
  customElements.define('quantity-selector', QuantitySelector);
}
